export const environment = {
  base_url: 'https://sandbox.service.authentication.verifiedge.com',
  allowed_origin: 'https://sandbox.app.authentication.verifiedge.com',
  dataLimit: '20',
  production: false,
};
